<template>
  <div class="SiteMap">
    <h2 class="sr-only">網站導覽</h2>
    <ListTitle title="網站導覽" />
    <div class="d-flex flex-column justify-center align-center">
      <div class="container" style="margin-bottom:2rem">
        <div style="margin-top:2rem">
          <div class="sectSubTitle">
            <div class="sectText">
              <p>
                本網站依無障礙網頁設計原則建置，網站的主要內容分為三大區塊：
                <br />1.導覽連結區、2.中央內容區塊、3.下方選單連結區塊。
              </p>
            </div>
          </div>
          <div class="sectSubTitle">
            <div class="sectText">
              <p>
                本網站的快速鍵﹝Accesskey﹞設定如下：
                <br />&emsp;Alt+U、Alt+Shift+U(Firefox)：上方導覽連結區，此區塊列有本網站主要連結。
                <br />&emsp;Alt+C、Alt+Shift+C(Firefox)：中央內容區塊，為本頁主要內容區。
                <br />&emsp;Alt+Z、Alt+Shift+Z(Firefox)：頁尾網站資訊。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="container" style="margin-bottom:2rem">
        <div class="row">
          <div
            v-for="(item, index) in pages"
            :key="index"
            class="col-12 col-lg-3 col-sm-4 guideButton"
          >
            <router-link
              tabindex="-1"
              :to="linkTo(item)"
              :title="'前往' + item.name"
              :id="item.name"
            >
              <div
                tabindex="0"
                :for="item.name"
                role="button"
                class="guideButtonIn ct-text-bolder"
                @click="toLink(item)"
                @keypress="toLink(item)"
              >
                {{ index + 1 + "." + item.name }}
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div class="container" style="margin-bottom:2rem">
        <span class="ct-text-bolder ct-text-subtitle3 d-block pb-2">
          外部連結
        </span>
        <v-container>
          <v-row>
            <v-col v-for="(item, idx) in relateList" :key="idx">
              <span class="ct-text-bolder">{{ item.name }}</span>
              <div
                v-for="(li, li_idx) in item.list"
                :key="li_idx"
                class="pl-4 py-1"
              >
                <a
                  :title="
                    normalizeExternalTitle(li) +
                      (normalizeExternalHref(li) ? '(另開新視窗)' : '')
                  "
                  :href="normalizeExternalHref(li)"
                  class="primary--text ct-text-bolder"
                  style="text-decoration: underline;"
                  target="_blank"
                >
                  {{ normalizeExternalTitle(li) }}
                </a>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/layouts/footer.vue";
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
export default {
  name: "SiteMap",
  components: {
    Footer,
    ListTitle
  },
  data: () => {
    return {
      pages: [
        { name: "首頁", link: "/" },
        { name: "最新消息", link: "/Announce/Index" },
        { name: "養護專區", link: "/Announce/MainTain" },
        { name: "關於我們", link: "/Announce/AboutUs" },
        { name: "常見Q&A", link: "/Announce/QA" },
        { name: "愛樹教育輔導團", link: "/Announce/FDEEGG" },
        { name: "校園樹木地圖", link: "/Map" },
        { name: "樹木小百科", link: "/Book" },
        { name: "植樹專家諮詢平臺", link: "/Consult" },
        { name: "愛樹教育", link: "/Education" },
        { name: "OpenData", link: "/OpenData" },
        { name: "網站導覽", link: "/SiteMap" },
        { name: "後臺登入(另開新視窗)", link: "/SiteMap" }
      ]
    };
  },
  computed: {
    relateList() {
      return this.$store.state.global.relateList;
    }
  },
  methods: {
    normalizeExternalTitle(item) {
      const rawTitle = item && item.title ? String(item.title) : "";
      const matchedTitle = rawTitle.match(/title\s*=\s*['"]([^'"]+)['"]/i);
      if (matchedTitle && matchedTitle[1]) {
        return matchedTitle[1].trim();
      }

      return rawTitle.replace(/<[^>]*>/g, "").trim();
    },
    normalizeExternalHref(item) {
      const rawTitle = item && item.title ? String(item.title) : "";
      const rawHref = item && item.to ? String(item.to) : "";

      let href = rawHref.trim();
      const matchedHref = rawTitle.match(/href\s*=\s*['"]([^'"]+)['"]/i);
      if (!href && matchedHref && matchedHref[1]) {
        href = matchedHref[1].trim();
      }

      const urlMatched = href.match(/https?:\/\/[^\s'"]+/i);
      if (urlMatched && urlMatched[0]) {
        return urlMatched[0];
      }

      return href;
    },
    linkTo(item) {
      let result = item.link;
      if (item.name == "使用者意見調查") {
        result = "/webGuidePage";
      } else if (item.name == "後臺系統") {
        result = "/webGuidePage";
      }
      return result;
    },
    toLink(item) {
      document.getElementById(item.name).click();
      if (item.name == "使用者意見調查") {
        window.open(item.link);
      } else if (item.name == "後臺登入(另開新視窗)") {
        window.open(`${process.env.VUE_APP_BACK_URL}`, "_blank");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.SiteMap {
  min-height: 100%;
  // filter: contrast(0.5);
  // background-size: cover;
  background-position: 50% 50%;
  background-repeat: repeat;
  background-image: url("~@/assets/images/announce/bg_title.png");
  a {
    text-decoration: none;
  }
}
.guideButton {
  margin-bottom: 1rem;
  color: white;
}

.guideButtonIn {
  padding: 1rem;
  height: 100%;
  width: 100%;
  background-color: #fffede;
}
</style>
